window.addEventListener('load', () => {
  if (window.Shopify.customerPrivacy?.userCanBeTracked()) {
    /* GOOGLE TAG MANAGER */
    // const shop = Shopify.shop?.split('.myshopify.com')[0];
    // switch (shop) {
    //   case 'apm-hk': // UK
    //     var container = 'GTM-MDHWG5P';
    //   case 'apm-mc': // US
    //     var container = 'GTM-MDHWG5P';
    //   case 'apm-fr': // FR
    //     var container = 'GTM-MSGBQVZ';
    //   case 'apm-uk': // INT
    //     var container = 'GTM-MDHWG5P';
    //   default:
    //     var container = 'GTM-MDHWG5P';
    // }
  
    /* GOOGLE ADWORDS */
    // window.dataLayer = window.dataLayer || [];
    // function gtag(){dataLayer.push(arguments);}
    // gtag('js', new Date());
    // gtag('config', 'AW-308770936');
  
    /* HOTJAR */
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2539240,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
});

/* LIVE CHAT */
(function(u,t,d){
  var i=d.createElement(t);i.type='text/javascript';i.async=true;i.src=u;
  var s=d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(i,s);
})('https://asia2-track.inside-graph.com/gtm/IN-1000872-US/include.js','script',document);

/* SPLITIT */
(function(i,s,o,g,r,a,m){i['SplititObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window, document, 'script', '//upstream.production.splitit.com/v1/dist/upstream-messaging.js?v=1', 'splitit');
splitit('init', { apiKey:  '8706c514-1720-49f4-afbd-551f4c3c9273', lang: 'en-US', currency: 'GBP', currencySymbol: '£', debug: false });

/* Line */
(function(g,d,o){
  g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
  var h=location.protocol==='https:'?'https://d.line-scdn.net':'http://d.line-cdn.net';
  var s=d.createElement('script');s.async=1;
  s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
  var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
    })(window, document);
_lt('init', {
  customerType: 'lap',
  tagId: '7ebd06ce-4734-4359-8800-84bdbb0bef01'
});
_lt('send', 'pv', ['7ebd06ce-4734-4359-8800-84bdbb0bef01']);


// Reload AfterShip Personalization after AJAX pagination
document.addEventListener('facet:update', function() {
  // Use requestAnimationFrame to ensure DOM is fully updated
  requestAnimationFrame(function() {
    if (window.AfterShipPersonalization && typeof window.AfterShipPersonalization.reload === 'function') {
      window.AfterShipPersonalization.reload();
    }
  });
});

const ACCOUNT_DOT_STORAGE_KEY = 'apm.headerAccountDotDismissed';

function dismissAccountDot() {
  try {
    window.localStorage.setItem(ACCOUNT_DOT_STORAGE_KEY, '1');
  } catch (e) {}
  document.documentElement.classList.add('account-dot-dismissed');
}

document.addEventListener('click', (event) => {
  const accountLink = event.target.closest?.('a');
  if (!accountLink?.querySelector('.header__account-dot')) return;
  dismissAccountDot();
});